import React, {useState, useEffect} from "react";
import './style.css';
import { Slant as Hamburger } from 'hamburger-react'
import Cursor from '../AnimatedCursor/Cursor';
import AOS from 'aos'
import "aos/dist/aos.css";
import { Link } from "react-scroll";

const data= [
    {
        id: 1,
        text: 'about',
        ref: 'about'
    },
    {
        id: 2,
        text: 'services',
        ref: 'services'
    },
    {
        id: 3,
        text: 'portfolio',
        ref: 'portfolio'
    },
    {
        id: 4,
        text: 'contact',
        ref: 'contact'
    }

]

function Navbar() {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
      }, []);

    const [scroll, setScroll] = useState(false);

    const changeBackground = () => {
        if (window.scrollY >= 66) {
          setScroll(true)
        } else {
          setScroll(false)
        }
      }
    
      useEffect(() => {
        changeBackground()
        window.addEventListener("scroll", changeBackground)
      })

  return (
      <section className="Navbar py-3 w-100" id="navbar" data-aos={"fade-down"} data-aos-duration={1000} data-aos-offset={0}
      style=
        {{ 
           boxShadow: scroll? '0px 2px 15px #3333334d' : '0px 0px 0px #3333334d',
        }}
      >
        <Cursor />
        <div className="container-lg px-1">
            <div className="row g-2 d-flex justify-content-between align-items-center">

                <div className="col-md-2 col-3 h-100 d-flex align-items-center">
                    <div className="navbar-brand Navbar__brand d-flex align-items-end fs-4 fw-bold ps-2">
                        <span className="Navbar__brand--color fw-bold">ashir</span>codes
                    </div>
                </div>
                
                <div className="col-md-9 d-md-flex d-none align-items-center justify-content-end">
                    <ul className=" Navbar__nav list-unstyled d-flex justify-content-end align-items-center m-0" id="nav">
                        <li className=" Navbar__nav__item d-flex align-items-center border-start border-end px-4 Navbar__nav__item--border">
                            <Link activeClass="active" offset={0} smooth spy delay={0} duration={500} to='home' className=" Navbar__nav__item__link text-decoration-none d-flex align-items-center text-uppercase">Home</Link>
                        </li>
                        {data.map((item)=>(
                            <li className=" Navbar__nav__item d-flex align-items-center px-4 border-end" key= {item.id}>
                            <Link activeClass="active" smooth spy to={item.ref} delay={0} duration={500} className=" Navbar__nav__item__link text-decoration-none d-flex align-items-center text-uppercase">{item.text}</Link>
                        </li>
                        ))}
                    </ul>
                </div>
                <div className="col-6 d-md-none h-100 d-flex justify-content-end py-0">
                    <div className="Hamburger-icon h-100" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                    <Hamburger className="Hamburger-icon" />
                    </div>
                </div>
            </div>
        </div>
    <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
    <ul className="hamburger__menu w-100 list-unstyled py-0">
        <li className="hamburger__menu__item py-2 ps-4">
                    <Link activeClass="active" smooth spy to="home" className="hamburger__menu__item__link text-uppercase text-decoration-none">home</Link></li>
            {data.map((item)=>(
                <li className="hamburger__menu__item py-2 px-4" key={item.id}>
                    <Link activeClass="active" smooth spy to={item.ref} className="hamburger__menu__item__link text-uppercase text-decoration-none">{item.text}</Link></li>
            ))}
        </ul>
  </div>
    
    </section>
  );
}

export default Navbar;
